import type { OrderTotalsData } from './types';

const TotalsRow = ({ label, value }: { label: string; value: number }) => (
  <div className="flex justify-between gap-4">
    <dt className="text-neutral-600">{label}</dt>
    <dd>
      {value.toLocaleString()}
      <span className="text-sm"> 円</span>
    </dd>
  </div>
);

export const OrderTotals = ({ totals }: { totals: OrderTotalsData }) => (
  <dl className="flex flex-col gap-1">
    <TotalsRow label="小計" value={totals.subtotal} />
    {totals.tax10Amount > 0 && <TotalsRow label="10%対象 消費税額" value={totals.tax10Amount} />}
    {totals.tax8Amount > 0 && <TotalsRow label="8%対象 消費税額" value={totals.tax8Amount} />}
    <TotalsRow label="消費税額合計" value={totals.taxTotal} />
    <div className="mt-1 flex justify-between gap-4 border-t border-neutral-300 pt-2 text-lg font-bold">
      <dt>合計金額</dt>
      <dd>
        {totals.totalAmount.toLocaleString()}
        <span className="text-sm"> 円</span>
      </dd>
    </div>
  </dl>
);
